<template>
    <v-container ref="container" fluid :style="containerStyle" class="b2b-auth-page h-100 d-flex align-center">
        <div class="mx-auto wrapper">
            <v-card width="100%" class="pt-9 pb-10 px-12">
                <v-card-title class="mb-2 text-h5 text-center" :style="{whiteSpace: 'normal'}">
                    {{ forgotPasswordStep ? $t('forgot_your_password') : `${$t('welcome_back')}` }}
                    <div class="text-h6 font-weight-light text-grey text-grey-darken-1 text-wrap">
                        {{ $t('you_log_in_as_a_partner') }}
                    </div>
                </v-card-title>
                <v-card-text v-if="!forgotPasswordStep" class="px-0">
                    <NewB2bAuthorizationForm
                        :recaptcha-token="recaptchaToken"
                        @click-forgot-password="forgotPasswordStep = true"
                        @auth-success="authSuccess"
                    />
                </v-card-text>
                <v-card-text v-else class="px-0">
                    <NewForgotPasswordForm is-b2b class="pt-5" @switch-to-login="forgotPasswordStep = false" />
                </v-card-text>
            </v-card>
            <client-only>
                <div v-if="$conf.public.recaptchaSiteKey" class="mt-2 d-flex justify-center">
                    <ReCaptcha
                        :site-key="$conf.public.recaptchaSiteKey"
                        @success="recaptchaToken = $event"
                        @on-error="recaptchaToken = null"
                        @on-expired="recaptchaToken = null"
                    />
                </div>
            </client-only>
        </div>
    </v-container>
</template>

<script lang="ts">
    import {Component, Vue, Hook} from 'vue-facing-decorator'
    import NewB2bAuthorizationForm from '~/components/account/forms/NewB2bAuthorizationForm.vue'
    import NewForgotPasswordForm from '~/components/account/forms/NewForgotPasswordForm.vue'

    @Component({
        components: {
            NewB2bAuthorizationForm,
            NewForgotPasswordForm,
            ReCaptcha: defineAsyncComponent(() => import('@/components/ReCaptcha.vue')),
        },
    })
    export class B2bAuthorizationPage extends Vue {
        forgotPasswordStep = false
        prevRoute = null
        recaptchaToken = null

        @Hook
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from
            })
        }

        async authSuccess() {
            const companyType = authStore.companyType

            if (companyType === 'INTERNAL_SUPPLIER') {
                this.$router.push({name: 'supplier'})
            } else if (
                this.prevRoute?.path.includes('/search/') ||
                ['hotel', 'transfer', 'activity', 'hotelDirectory', 'favorites'].includes(this.prevRoute?.name)
            ) {
                this.goBack()
            } else {
                this.$router.push({name: 'orders'})
            }
        }

        goBack() {
            this.$router.go(-1)
        }

        get containerStyle() {
            return {
                'background-image': 'url(/b2b-login-bg.jpg)',
                'background-size': 'cover',
                'background-position': '50%',
            }
        }
    }

    export default B2bAuthorizationPage
</script>

<style scoped lang="scss">
    .b2b-auth-page {
        background-color: var(--zsh-primary-dark);
        background-image: none !important;
    }
    .wrapper {
        max-width: 412px;
        width: 100%;
    }
</style>
